import { CUSTOMER_API_BASE_URL } from '../config/env';

export interface MarketingMessage {
  role: 'user' | 'assistant';
  text: string;
  attachments: Array<{ type: string; name: string; mimeType?: string; fetchedUrl?: string }>;
  createdAt: string;
}

export interface AttachmentPayload {
  type: 'image' | 'pdf' | 'video' | 'url';
  name: string;
  mimeType?: string;
  data?: string; // base64
  url?: string;
}

export const marketingAgentService = {
  async sendMessage(text: string, attachments: AttachmentPayload[] = []): Promise<string> {
    const res = await fetch(`${CUSTOMER_API_BASE_URL}/api/marketing-agent/message`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, attachments }),
    });
    if (!res.ok) throw new Error(`API error ${res.status}`);
    const data = await res.json() as { response: string };
    return data.response;
  },

  async getHistory(limit = 100): Promise<MarketingMessage[]> {
    const res = await fetch(`${CUSTOMER_API_BASE_URL}/api/marketing-agent/history?limit=${limit}`);
    if (!res.ok) throw new Error(`API error ${res.status}`);
    const data = await res.json() as { messages: MarketingMessage[] };
    return data.messages;
  },
};
